module.exports = __webpack_public_path__ + "img/ShareMobile.eecf36e0.svg";